import { loginAffiliateAuthentication } from "../../lib/loginAffiliateAuthentication";
import { loginAuthentication } from "../../lib/loginAuthentication";

import {
  formatError,
  runLogoutTimer,
  saveTokenAffiliateInLocalStorage,
  saveTokenInLocalStorage,
  signUp,
} from "../../services/AuthService";

export const SIGNUP_CONFIRMED_ACTION = "[signup action] confirmed signup";
export const SIGNUP_FAILED_ACTION = "[signup action] failed signup";
export const LOGIN_CONFIRMED_ACTION = "[login action] confirmed login";
export const LOGIN_FAILED_ACTION = "[login action] failed login";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";
export const LOGOUT_ACTION = "[Logout action] logout action";

export function signupAction(email, password, navigate) {
  return async (dispatch) => {
    try {
      const response = await signUp(email, password);
      saveTokenInLocalStorage(response.data);
      runLogoutTimer(dispatch, response.data.expiresIn * 1000);
      dispatch(confirmedSignupAction(response.data));
      navigate("/dashboard");
    } catch (error) {
      const errorMessage = formatError(error.response.data);
      dispatch(signupFailedAction(errorMessage));
    }
  };
}

export function Logout(navigate) {
  localStorage.removeItem("userDetails");
  navigate("/login");

  return {
    type: LOGOUT_ACTION,
  };
}

export function LogoutAffiliate(navigate) {
  localStorage.removeItem("userDetailsAfiliate");
  navigate("/afiliado/login");
  return {
    type: LOGOUT_ACTION,
  };
}
export function loginAction(email, password, navigate) {
  return async (dispatch) => {
    const input = {
      email,
      password,
      expireDate: "2026-02-10T22:21:37.368Z",
      displayName: "",
      expiresIn: "3600",
      idToken: "eyJhbGciOiJSUzI1NiIsImtpZCI6IjVhNTA5ZjAxOWY3MGQ3NzlkODBmMTUyZDFhNWQzMzgxMWFiN2NlZjciLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vcmVhY3QtY291cnNlLWI3OThlIiwiYXVkIjoicmVhY3QtY291cnNlLWI3OThlIiwiYXV0aF90aW1lIjoxNjc2MDY0MDk3LCJ1c2VyX2lkIjoicW10NmRSeWlwSWFkOFVDYzBRcE1WMk1FTlN5MSIsInN1YiI6InFtdDZkUnlpcElhZDhVQ2MwUXBNVjJNRU5TeTEiLCJpYXQiOjE2NzYwNjQwOTcsImV4cCI6MTY3NjA2NzY5NywiZW1haWwiOiJkZW1vQGV4YW1wbGUuY29tIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJmaXJlYmFzZSI6eyJpZGVudGl0aWVzIjp7ImVtYWlsIjpbImRlbW9AZXhhbXBsZS5jb20iXX0sInNpZ25faW5fcHJvdmlkZXIiOiJwYXNzd29yZCJ9fQ.IFrEcjjOm1Vb6aKS005k--TKIcEHlSDMDhUlx5tgGZ_TUIg7k9oIGQbscdHbVuPvCquAu-r_oxWtjOOqdRh3abv49eTFS3dIWNoW2vEbdwNFjllxoNP3vpheIbmCqgV7nkjF2Xr4L1Qt6o6fKSZu_iadCqHCXm_33iK52OFTusw2_en0oJBaRQsgJAhon85wR1_hOGzOce7nT2qEAcxdXdS7GJSDHsNp_xX-Y1jPaJAz4XcxW2tXIiltDwQ9pitNZNcFEPrsrb2J1PJBcntup-Rz6-M0YJeXAkZAYjHEd6fnOxYz4T_2sq4-4BCF3WM40pRpoJFpxRWsBiX3czNhKQ",
      kind: "identitytoolkit#VerifyPasswordResponse",
      localId: "qmt6dRyipIad8UCc0QpMV2MENSy1",
      refreshToken: "APJWN8cXU_VfTry07gyPRPkmgqv123iuetnI0yp9ZHJzxoTCW5fxtvwmQFv7CtOpdEnCtd-KadJVOCRqzoqs89u7oHu16mlddh6ln-KKq-PLHOSH1PcJh_TKor-3M6bwFoHx5tsPUB2JNPqrYgxragbj17D0Md--xZQgmQ1lKjaPiSzrPfMOY-70bDl3s4rSDX5c5JvJVVl4lxQyRN2STrikiMO6zletVw",
      registered: true,
    };

    try {
      const response = await loginAuthentication(input);
      const { data } = response;
      const { user } = data;

      if (data.status) {
        saveTokenInLocalStorage({
          ...input,
          ...user,
          companyProfile: data.companyProfile,
        });
        debugger
        runLogoutTimer(dispatch, 36000000, navigate);
        dispatch(loginConfirmedAction(input));
        navigate("/dashboard");
      } else {
        debugger
        dispatch(loginFailedAction("Los datos ingresados son incorrectos."));
      }
    } catch (error) {
      const errorMessage = formatError(error.response.data);
      dispatch(loginFailedAction(errorMessage));
    }
  };
}

export  function loginAffiliateAction(cuil, navigate) {
  return async (dispatch) => {
    debugger
    const input = {
      cuil,
      expireDate: "2026-02-10T22:21:37.368Z",
      displayName: "",
      expiresIn: "14400",
      idToken: "eyJhbGciOiJSUzI1NiIsImtpZCI6IjVhNTA5ZjAxOWY3MGQ3NzlkODBmMTUyZDFhNWQzMzgxMWFiN2NlZjciLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vcmVhY3QtY291cnNlLWI3OThlIiwiYXVkIjoicmVhY3QtY291cnNlLWI3OThlIiwiYXV0aF90aW1lIjoxNjc2MDY0MDk3LCJ1c2VyX2lkIjoicW10NmRSeWlwSWFkOFVDYzBRcE1WMk1FTlN5MSIsInN1YiI6InFtdDZkUnlpcElhZDhVQ2MwUXBNVjJNRU5TeTEiLCJpYXQiOjE2NzYwNjQwOTcsImV4cCI6MTY3NjA2NzY5NywiZW1haWwiOiJkZW1vQGV4YW1wbGUuY29tIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJmaXJlYmFzZSI6eyJpZGVudGl0aWVzIjp7ImVtYWlsIjpbImRlbW9AZXhhbXBsZS5jb20iXX0sInNpZ25faW5fcHJvdmlkZXIiOiJwYXNzd29yZCJ9fQ.IFrEcjjOm1Vb6aKS005k--TKIcEHlSDMDhUlx5tgGZ_TUIg7k9oIGQbscdHbVuPvCquAu-r_oxWtjOOqdRh3abv49eTFS3dIWNoW2vEbdwNFjllxoNP3vpheIbmCqgV7nkjF2Xr4L1Qt6o6fKSZu_iadCqHCXm_33iK52OFTusw2_en0oJBaRQsgJAhon85wR1_hOGzOce7nT2qEAcxdXdS7GJSDHsNp_xX-Y1jPaJAz4XcxW2tXIiltDwQ9pitNZNcFEPrsrb2J1PJBcntup-Rz6-M0YJeXAkZAYjHEd6fnOxYz4T_2sq4-4BCF3WM40pRpoJFpxRWsBiX3czNhKQ",
      kind: "identitytoolkit#VerifyPasswordResponse",
      localId: "qmt6dRyipIad8UCc0QpMV2MENSy1",
      refreshToken: "APJWN8cXU_VfTry07gyPRPkmgqv123iuetnI0yp9ZHJzxoTCW5fxtvwmQFv7CtOpdEnCtd-KadJVOCRqzoqs89u7oHu16mlddh6ln-KKq-PLHOSH1PcJh_TKor-3M6bwFoHx5tsPUB2JNPqrYgxragbj17D0Md--xZQgmQ1lKjaPiSzrPfMOY-70bDl3s4rSDX5c5JvJVVl4lxQyRN2STrikiMO6zletVw",
      registered: true,
    };

    try {
      const response = await loginAffiliateAuthentication(input);
      debugger
  


      if (response.status === 200) {
        const { data } = response;
        const { employee } = data.data;

        saveTokenAffiliateInLocalStorage({
          ...input,
          employee:employee,
        });
        runLogoutTimer(dispatch, 36000000, navigate);
        dispatch(loginConfirmedAction(input));
        if(employee.firstlog){
          navigate("/afiliado/");
        }else{
          navigate("/afiliado/edit-afiliado");
        }
       
      } else if (response.status === 400) {
        dispatch(loginFailedAction("Tu CUIL no es valido. Si no podes ingresar comunicate a <a href='mailto:afiliaciones@unioninformatica.org'>afiliaciones@unioninformatica.org  </a>"));
      } else {
        dispatch(loginFailedAction("Los datos ingresados son incorrectos."));
      }
    } catch (error) {
      const errorMessage = formatError(error.response.data);
      dispatch(loginFailedAction(errorMessage));
    }
  };
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}
